import React from "react";
import DialogConfirmButtons from "../../../../common/dialogConfirmButtons/DialogConfirmButtons";
import SuccessMessage from "../../../../messages/SuccessMessage";

const MfaEnrollmentDeletedStep = ({ busy, user, onCompleted }) => {
  const onDoneClicked = () => {
    onCompleted();
  };

  const buttons = (
    <DialogConfirmButtons
      appearBusy={busy}
      confirmBtnEnabled={true}
      confirmBtnLabel="Done"
      onConfirm={onDoneClicked}
      omitCancelBtn={true}
    />
  );

  return (
    <div id="email-changed-step">
      <div className="delete-mfa-enrollment-step-body">
        <SuccessMessage
          className="email-access-verified-success-message"
          message={`MFA enrollment for ${user?.email} has been deleted.`}
        />
      </div>
      {buttons}
    </div>
  );
};

export default MfaEnrollmentDeletedStep;
